import { Title } from "@mantine/core";
import type { ReactNode } from "react";

interface IHelpCenterSubTitleProps {
  children: ReactNode | string;
}

const HelpCenterSubTitle: React.FC<IHelpCenterSubTitleProps> = ({
  children,
}) => {
  return (
    <Title fz={24} order={3} className="pt-5 font-secret-black">
      {children}
    </Title>
  );
};

export default HelpCenterSubTitle;
